var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { sortBy } from "lodash";
import moment from 'moment';
export var textDate = function (time) {
    // 2020-01-30 18:30:00 UTC
    var momentCalendarConfig = {
        sameDay: '[Today at] h:mm a',
        nextDay: '[Tomorrow at] h:mm a',
        lastDay: '[Yesterday at] h:mm a',
        lastWeek: 'MM/DD/YYYY h:mm a',
        sameElse: 'MM/DD/YYYY h:mm a',
        nextWeek: 'MM/DD/YYYY h:mm a',
    };
    try {
        return moment(time, "YYYY-MM-DD hh:mm:ss").calendar(0, momentCalendarConfig);
    }
    catch (e) { }
    return '';
};
export var filterFormatter = function (filters) {
    var _a;
    var formattedFilters = undefined;
    if (filters) {
        formattedFilters = {};
        (_a = Object.keys(filters)) === null || _a === void 0 ? void 0 : _a.forEach(function (filterKey) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
            var filterVal = filters === null || filters === void 0 ? void 0 : filters[filterKey];
            if (filterKey === "sortOrder") {
                if (filterVal)
                    formattedFilters["isAscending"] = filterVal === "ascend";
            }
            else if (filterKey === "brandId" && ((_a = filterVal === null || filterVal === void 0 ? void 0 : filterVal[0]) === null || _a === void 0 ? void 0 : _a.includes("-"))) {
                formattedFilters[filterKey] = (_c = (_b = filterVal === null || filterVal === void 0 ? void 0 : filterVal[0]) === null || _b === void 0 ? void 0 : _b.split("-")) === null || _c === void 0 ? void 0 : _c[0];
            }
            else if (filterKey === "isPublish" || filterKey === "environment") {
                if ((filterVal === null || filterVal === void 0 ? void 0 : filterVal.length) > 1)
                    formattedFilters[filterKey] = undefined;
                else
                    formattedFilters[filterKey] = filterVal;
            }
            else if (Array.isArray(filterVal) && (((_d = filterVal === null || filterVal === void 0 ? void 0 : filterVal[0]) === null || _d === void 0 ? void 0 : _d.from) || ((_e = filterVal === null || filterVal === void 0 ? void 0 : filterVal[0]) === null || _e === void 0 ? void 0 : _e.to))) {
                if (((_f = filterVal === null || filterVal === void 0 ? void 0 : filterVal[0]) === null || _f === void 0 ? void 0 : _f.from) && ((_g = filterVal === null || filterVal === void 0 ? void 0 : filterVal[0]) === null || _g === void 0 ? void 0 : _g.to)) {
                    formattedFilters[filterKey] = filterVal;
                }
                else if (((_h = filterVal === null || filterVal === void 0 ? void 0 : filterVal[0]) === null || _h === void 0 ? void 0 : _h.from) && !((_j = filterVal === null || filterVal === void 0 ? void 0 : filterVal[0]) === null || _j === void 0 ? void 0 : _j.to)) {
                    formattedFilters[filterKey] = (_k = filterVal === null || filterVal === void 0 ? void 0 : filterVal[0]) === null || _k === void 0 ? void 0 : _k.from;
                }
                else if (!((_l = filterVal === null || filterVal === void 0 ? void 0 : filterVal[0]) === null || _l === void 0 ? void 0 : _l.from) && ((_m = filterVal === null || filterVal === void 0 ? void 0 : filterVal[0]) === null || _m === void 0 ? void 0 : _m.to)) {
                    formattedFilters[filterKey] = (_o = filterVal === null || filterVal === void 0 ? void 0 : filterVal[0]) === null || _o === void 0 ? void 0 : _o.to;
                }
            }
            else {
                formattedFilters[filterKey] = filterVal;
            }
        });
    }
    return formattedFilters;
};
export var sortedColumnDetails = function (columnMap) {
    var _a;
    if (!columnMap)
        return undefined;
    var sortedKey = undefined, sortOrder = undefined;
    (_a = Object.keys(columnMap)) === null || _a === void 0 ? void 0 : _a.forEach(function (columnKey) {
        var columnVal = columnMap === null || columnMap === void 0 ? void 0 : columnMap[columnKey];
        if (columnVal === null || columnVal === void 0 ? void 0 : columnVal.order) {
            sortedKey = columnKey;
            sortOrder = columnVal === null || columnVal === void 0 ? void 0 : columnVal.order;
        }
    });
    return sortedKey && sortOrder ? { key: sortedKey, order: sortOrder } : undefined;
};
export var formatColumns = function (columns, savedColumnMap, defaultVisibleColumns, filtersTouched) {
    var sortedColumns = sortBy(columns, function (ob) {
        var _a;
        return (_a = savedColumnMap === null || savedColumnMap === void 0 ? void 0 : savedColumnMap[ob === null || ob === void 0 ? void 0 : ob.key]) === null || _a === void 0 ? void 0 : _a.index;
    });
    var finalColumnList = [], finalVisibleColumns = [];
    sortedColumns.forEach(function (col) {
        var _a, _b, _c, _d;
        var savedWidth = (_a = savedColumnMap === null || savedColumnMap === void 0 ? void 0 : savedColumnMap[col === null || col === void 0 ? void 0 : col.key]) === null || _a === void 0 ? void 0 : _a.width;
        var filters = (_b = savedColumnMap === null || savedColumnMap === void 0 ? void 0 : savedColumnMap[col.key]) === null || _b === void 0 ? void 0 : _b.filter;
        var order = (_c = savedColumnMap === null || savedColumnMap === void 0 ? void 0 : savedColumnMap[col.key]) === null || _c === void 0 ? void 0 : _c.order;
        if (savedWidth && savedWidth > 0)
            col.width = savedWidth;
        if (filters) {
            if (filtersTouched) {
                col.filteredValue = filters;
                col.defaultFilteredValue = undefined;
            }
            else {
                col.filteredValue = undefined;
                col.defaultFilteredValue = filters;
            }
        }
        if (order)
            col.defaultSortOrder = order;
        finalColumnList.push(col);
        if ((_d = savedColumnMap === null || savedColumnMap === void 0 ? void 0 : savedColumnMap[col === null || col === void 0 ? void 0 : col.key]) === null || _d === void 0 ? void 0 : _d.isVisible)
            finalVisibleColumns.push(col === null || col === void 0 ? void 0 : col.key);
    });
    if ((finalVisibleColumns === null || finalVisibleColumns === void 0 ? void 0 : finalVisibleColumns.length) === 0 && defaultVisibleColumns && (defaultVisibleColumns === null || defaultVisibleColumns === void 0 ? void 0 : defaultVisibleColumns.length) > 0)
        finalVisibleColumns = defaultVisibleColumns;
    var finalData = {
        allColumns: finalColumnList,
        visibleColumns: finalVisibleColumns
    };
    return finalData;
};
export var cobrandFilterListFormatter = function (stageCobrandList, prodCobrandList, searchString, selectedValue) {
    var _a, _b;
    var selectedVal = selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue[0];
    var matchedArray = [];
    var matchedValue = undefined;
    var searchedString = (searchString || "").toLowerCase();
    (_a = (prodCobrandList || [])) === null || _a === void 0 ? void 0 : _a.forEach(function (cobrand) {
        var _a, _b, _c, _d;
        if (cobrand.id + "-" + cobrand.dataBase === selectedVal)
            matchedValue = __assign(__assign({}, cobrand), { envKey: "PROD" });
        else if (((_b = (_a = cobrand === null || cobrand === void 0 ? void 0 : cobrand.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(searchedString || "")) || ((_d = (_c = cobrand === null || cobrand === void 0 ? void 0 : cobrand.id) === null || _c === void 0 ? void 0 : _c.toString()) === null || _d === void 0 ? void 0 : _d.includes(searchedString || "")))
            matchedArray.push(__assign(__assign({}, cobrand), { envKey: "PROD" }));
    });
    (_b = (stageCobrandList || [])) === null || _b === void 0 ? void 0 : _b.forEach(function (cobrand) {
        var _a, _b, _c, _d;
        if (cobrand.id + "-" + cobrand.dataBase === selectedVal)
            matchedValue = __assign(__assign({}, cobrand), { envKey: "STAGE" });
        else if (((_b = (_a = cobrand === null || cobrand === void 0 ? void 0 : cobrand.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(searchedString || "")) || ((_d = (_c = cobrand === null || cobrand === void 0 ? void 0 : cobrand.id) === null || _c === void 0 ? void 0 : _c.toString()) === null || _d === void 0 ? void 0 : _d.includes(searchedString || "")))
            matchedArray.push(__assign(__assign({}, cobrand), { envKey: "STAGE" }));
    });
    if (matchedValue)
        matchedArray.unshift(matchedValue);
    return matchedArray;
};
export function arrayToMap(existingArray, keyForMap) {
    if (!existingArray || !Array.isArray(existingArray) || (existingArray === null || existingArray === void 0 ? void 0 : existingArray.length) === 0)
        return { columnMap: {} };
    var columnMap = existingArray.reduce(function (map, obj, indx) {
        map[obj === null || obj === void 0 ? void 0 : obj[keyForMap]] = obj;
        return map;
    }, {});
    return columnMap;
}
//# sourceMappingURL=notifications.js.map